// extracted by mini-css-extract-plugin
export default {"location-article":"locationarticle_location-article__XkLok","subheader":"locationarticle_subheader__BvRnb","detail":"locationarticle_detail__0qY3y"};